import { create } from 'zustand';

export const useDirectMessageStore = create((set, get) => ({
  conversations: [
    {
      id: 'dm-1',
      userId: 'user-2',
      userName: 'Alex Rivera',
      avatar: '🎮',
      lastMessage: 'Hey! Did you see the updates?',
      timestamp: Date.now() - 300000,
      unread: 2,
      messages: [
        {
          id: 'msg-1',
          senderId: 'user-2',
          text: 'Hey! Did you see the updates?',
          timestamp: Date.now() - 300000,
        },
        {
          id: 'msg-2',
          senderId: 'user-1',
          text: 'Just got them pushed through!',
          timestamp: Date.now() - 240000,
        },
      ],
    },
  ],
  
  currentConversationId: null,

  setCurrentConversation: (conversationId) =>
    set(() => ({
      currentConversationId: conversationId,
    })),

  getCurrentConversation: () => {
    const { conversations, currentConversationId } = get();
    return conversations.find((c) => c.id === currentConversationId);
  },

  addMessage: (conversationId, message) =>
    set((state) => ({
      conversations: state.conversations.map((c) =>
        c.id === conversationId
          ? {
              ...c,
              messages: [...c.messages, message],
              lastMessage: message.text,
              timestamp: message.timestamp,
            }
          : c
      ),
    })),

  createConversation: (userId, userName, avatar) =>
    set((state) => {
      const existingConv = state.conversations.find((c) => c.userId === userId);
      if (existingConv) return state;
      
      const newConv = {
        id: `dm-${userId}`,
        userId,
        userName,
        avatar,
        lastMessage: '',
        timestamp: Date.now(),
        unread: 0,
        messages: [],
      };
      return {
        conversations: [...state.conversations, newConv],
      };
    }),

  markread: (conversationId) =>
    set((state) => ({
      conversations: state.conversations.map((c) =>
        c.id === conversationId ? { ...c, unread: 0 } : c
      ),
    })),
}));
